<div _ngcontent-flv-c29="" class="row">
    <div _ngcontent-flv-c29="" class="col-md-12 text-center">
      <img _ngcontent-flv-c29="" src="../../assets/mapa.jpg" alt="" style="width: 83%;">
    </div>
  </div>